import nookies from 'nookies'

const COOKIE_CONSENT_NAME = 'cookies-are-accepted'

const getCookieConsentValue = (): boolean => {
  const cookiesAccepted = nookies.get()[COOKIE_CONSENT_NAME]

  return cookiesAccepted === 'true'
}

export default getCookieConsentValue
